import React from "react";
import { Link } from "react-router-dom";
import WhiteLogo from "../../assets/images/disktop-logo.png";

const VendorFooter = () => {
  return (
    <footer className="bg-[linear-gradient(90deg,#2A2A2A_0%,#111827_100%)]">
      <div className="container px-6 md:px-12 py-6 text-white">
        {/* Top Section */}
        <div className="flex justify-between flex-wrap gap-y-6">
          {/* Left Logo Section */}
          <div>
            <img src={WhiteLogo} alt="logo" className="w-30 h-12" />
            <p className="mt-3 text-sm max-w-xs">
              Dive into local recommendations for a truly authentic experience.
            </p>
          </div>

          {/* Middle Links Section */}
          <div>
            <h4 className="text-sm font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/faqs" className="hover:text-white transition">
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/first-flight"
                  className="hover:text-white transition"
                >
                  First Flight Fund
                </Link>
              </li>
            </ul>
          </div>

          {/* Right Contact Section */}
          <ul className="text-sm space-y-4 max-w-sm">
            {/* Location */}
            {/* <li className="flex items-start gap-2">
              <svg width="16" height="23" viewBox="0 0 16 23" fill="none">
                <path
                  d="M8.00016 5C4.805 5 2.20557 7.59944 2.20557 10.7946C2.20557 14.7598 7.39116 20.581 7.61194 20.8269C7.81932 21.0579 8.18138 21.0575 8.38838 20.8269C8.60916 20.581 13.7948 14.7598 13.7948 10.7946C13.7947 7.59944 11.1953 5 8.00016 5Z"
                  fill="white"
                />
              </svg>
              1237 Washington Ave. Manchester, Kentucky 12495
            </li> */}

            {/* Hours */}
            {/* <li className="flex items-start gap-2">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path
                  d="M7.33334 0C3.28494 0 0 3.28494 0 7.33334C0 11.3817 3.28494 14.6667 7.33334 14.6667C11.3817 14.6667 14.6667 11.3817 14.6667 7.33334Z"
                  fill="white"
                />
              </svg>
              Hours: 8:00 – 17:00, Mon – Sat
            </li> */}

            {/* Email */}
            <li className="flex items-start gap-2">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M1 4L8 9L15 4" stroke="white" strokeWidth="1.5" />
              </svg>
              support@toucan.com
            </li>
          </ul>
        </div>

        <hr className="border-gray-700 my-6" />

        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-gray-300 mb-4">
          <Link to="/privacy-policy" className="hover:text-white transition">
            Privacy Policy
          </Link>

          <Link to="/terms-of-service" className="hover:text-white transition">
            Terms of Service
          </Link>

          <Link
            to="/refund-cancellation"
            className="hover:text-white transition"
          >
            Refund & Cancellation Policy
          </Link>

          {/* <Link to="/accessibility" className="hover:text-white transition">
            Accessibility Statement
          </Link> */}
        </div>

        <p className="text-center text-white text-xs">
          © 2025 Toucan Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default VendorFooter;
